import * as React from 'react';
import { ScrollIntoView, Alert } from '@grandvisionhq/common';

/** Helper component to render Alert message */ const ErrorAlert = ({ message  })=>{
    return /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: message
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: message
    }));
};

export { ErrorAlert };
//# sourceMappingURL=ErrorAlert.js.map
